import { combineReducers } from 'redux';
import * as types from './types';
import * as patientTypes from '../patient/types';
import * as appTypes from '../app/appTypes';

import createReducer from '../../reducerHelper';
import { isLoadingDataState, dataSourceFailure } from '../../utils';

const searchForceRefreshReducer = createReducer(false)({
  [patientTypes.UPDATE_PATIENT_TRIGGER]: () => true,
  [types.SEARCH_FORCE_REFRESH]: (state, action) => action.payload || false,
});

const searchBarFieldsReducer = createReducer({
  results: [],
})({
  [types.PATIENT_SEARCH_FIELDS]: (state, action) => action.payload,
});

const searchCurrentPageReducer = createReducer(1)({
  [types.UPDATE_SEARCH_CURRENT_PAGE]: (state, action) => action.payload,
});

const searchCurrentSortReducer = createReducer({})({
  [types.UPDATE_SEARCH_CURRENT_SORT]: (state, action) => action.payload,
});

const patientResults = (state, action) => action.payload;

const patientResultReducer = createReducer([])({
  [appTypes.CLEAR_STATE]: () => [],
  [`${types.GET_PATIENT_RESULTS}_REJECTED`]: dataSourceFailure,
  [`${types.GET_PATIENT_RESULTS}_PENDING`]: isLoadingDataState,
  [`${types.GET_PATIENT_RESULTS}_FULFILLED`]: patientResults,
});

/*
  Shape: {
    pages,
    hasNextPage,
    totalRecords,
    participants,
    currentPage,
    pageLimit,
    totalPagesFetched,
  }
 */
export const initialScrollablePatientResults = {
  searchPerformed: false,
  isFetching: false,
  results: [],
  pages: [],
  totalRecords: 0,
  totalPagesFetched: 0,
};

const infScrollablePatientResultsReducer = (
  state = initialScrollablePatientResults,
  action,
) => {
  const { payload } = action;
  switch (action.type) {
    case appTypes.CLEAR_STATE:
      return initialScrollablePatientResults;

    case types.CLEAR_SEARCH_RESULTS:
      return initialScrollablePatientResults;

    case `${types.PAGE_INFINITE_SCROLL_PATIENT_RESULT}_PENDING`:
    case `${types.GET_INFINITE_SCROLL_PATIENT_RESULT}_PENDING`:
      return {
        ...state,
        searchPerformed: true,
        isFetching: true,
      };

    case `${types.PAGE_INFINITE_SCROLL_PATIENT_RESULT}_REJECTED`:
    case `${types.GET_INFINITE_SCROLL_PATIENT_RESULT}_REJECTED`:
      return {
        ...state,
        searchPerformed: true,
        isFetching: false,
        ...dataSourceFailure(state, action),
      };

    case `${types.GET_INFINITE_SCROLL_PATIENT_RESULT}_FULFILLED`:
      return {
        ...payload,
        searchPerformed: true,
        isFetching: false,
        results: payload.results,
        totalPagesFetched: 1,
        pages: {
          [payload.currentPage]: {
            page: payload.currentPage,
            pageLimit: payload.pageLimit,
          },
        },
      };

    case `${types.PAGE_INFINITE_SCROLL_PATIENT_RESULT}_FULFILLED`:
      return {
        ...payload,
        searchPerformed: true,
        isFetching: false,
        results: [...state.results, ...payload.results],
        totalPagesFetched: state.totalPagesFetched + 1,
        pages: (() => {
          const pages = { ...state.pages };
          pages[payload.currentPage] = {
            page: payload.currentPage,
            pageLimit: payload.pageLimit,
          };
          return pages;
        })(),
      };

    default:
      return state;
  }
};
/* used by redux-form */
export const SEARCH_FORM_REDUCERS = {
  PATIENT_SEARCH: 'patientSearchForm',
};

export const SEARCH_REDUCERS = {
  INFINITE_SCROLL_REDUCER: 'infiniteScrollPatientSearchResults',
  PATIENT_SEARCH_REDUCER: 'patientSearchResults',
  SEARCH_BAR_FIELDS: 'searchBarFields',
  SEARCH_CURRENT_PAGE: 'searchCurrentPage',
  SEARCH_CURRENT_SORT: 'searchCurrentSort',
  SEARCH_FORCE_REFRESH: 'searchForceRefresh',
};

export default combineReducers({
  [SEARCH_REDUCERS.PATIENT_SEARCH_REDUCER]: patientResultReducer,
  [SEARCH_REDUCERS.INFINITE_SCROLL_REDUCER]: infScrollablePatientResultsReducer,
  [SEARCH_REDUCERS.SEARCH_BAR_FIELDS]: searchBarFieldsReducer,
  [SEARCH_REDUCERS.SEARCH_CURRENT_PAGE]: searchCurrentPageReducer,
  [SEARCH_REDUCERS.SEARCH_CURRENT_SORT]: searchCurrentSortReducer,
  [SEARCH_REDUCERS.SEARCH_FORCE_REFRESH]: searchForceRefreshReducer,
});



// WEBPACK FOOTER //
// ./src/state/reducers/search/searchReducers.js